import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from 'app/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'app/components/ui/table';
import { useDashboardSlice } from '../../slice';
import { useEffect } from 'react';
import { formatDistanceToNow } from 'date-fns';
import { Link } from 'react-router-dom';
import { PAYMENT_STATUS_DETAILS } from 'utils/constants';
import {
  ArrowLeftRight,
  ArrowRight,
  CreditCard,
  ArrowDown,
  ArrowUp,
} from 'lucide-react';
import { useSelector } from 'react-redux';
import { selectSettings } from 'app/slice/selectors';
import { convertDateFormat } from 'utils/format-date';

export function RecentWalletTransactions() {
  const settings = useSelector(selectSettings);
  const { useGetRecentWalletTransactionsQuery } = useDashboardSlice();
  const [getRecentTransactions, { data: recentTransactions }] =
    useGetRecentWalletTransactionsQuery({});

  useEffect(() => {
    getRecentTransactions();
  }, []);

  return (
    <Card className="border-none bg-white  dark:bg-transparent rounded-2xl overflow-hidden">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 py-3 bg-[#059669] text-white">
        {' '}
        <CardTitle className="text-md font-medium flex items-center gap-2">
          <ArrowLeftRight className="w-4 h-4" />
          Recent Wallet Transactions
        </CardTitle>
        <Link
          to="/transactions"
          className="text-xs text-white hover:underline uppercase flex items-center gap-1"
        >
          View All <ArrowRight className="w-4 h-4" />
        </Link>
      </CardHeader>
      <CardContent className="mt-4 overflow-x-auto max-h-[530px] overflow-y-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="text-gray-500 text-xs uppercase whitespace-nowrap">
                Username
              </TableHead>
              <TableHead className="text-gray-500 text-xs uppercase">
                Total
              </TableHead>
              <TableHead className="text-gray-500 text-xs uppercase">
                Description
              </TableHead>
              <TableHead className="text-gray-500 text-xs uppercase whitespace-nowrap">
                Date
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {recentTransactions?.data?.length ? (
              recentTransactions.data.map(transaction => {
                const paymentStatus =
                  PAYMENT_STATUS_DETAILS[transaction.payment_status];

                return (
                  <TableRow
                    key={transaction.transaction_id}
                    className="hover:bg-gray-50"
                  >
                    <TableCell>{transaction?.username}</TableCell>
                    <TableCell>
                      {settings?.currency}{' '}
                      {
                        <span
                          className={`text-xs ${
                            transaction?.type === 'credit'
                              ? 'text-green-500'
                              : 'text-red-500'
                          } flex items-center gap-1`}
                        >
                          {transaction?.type === 'credit' ? (
                            <ArrowUp className="w-3 h-3" />
                          ) : (
                            <ArrowDown className="w-3 h-3" />
                          )}
                          {transaction?.amount}
                        </span>
                      }
                    </TableCell>
                    <TableCell>
                      {transaction?.description
                        ? transaction?.description
                        : transaction?.notes}
                    </TableCell>
                    <TableCell>
                      {convertDateFormat(transaction.created_at)}
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell
                  colSpan={6}
                  className="text-center text-gray-400 py-8"
                >
                  No recent orders found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
